import React, { useState } from "react";
import { post } from "../../lib/Fetching";
import Button from "../Button";
import AdditionalTestingSelector from "./AdditionalTestingSelector";
import ExistingSampleQuotables from "./ExistingSampleQuotables";

export default function RequestedTesting({
  sampleId,
  clientSpecificationId,
  onChange,
  companyId,
  displayOnly = false,
}) {
  const [withdrawing, setWithdrawing] = useState([]);
  const [quoteItemIds, setQuoteItemIds] = useState([]);
  const [version, setVersion] = useState(1);
  const [pleaseWait, setPleaseWait] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleSubmit = () => {
    if (withdrawing.length === 0 && quoteItemIds.length === 0) {
      alert("There are no changes to save.");
      return;
    }

    setPleaseWait(true);

    post("/registration/samples/update_requested_testing", {
      sample_id: sampleId,
      quote_item_ids: quoteItemIds,
      withdrawing,
    })
      .then((json) => {
        setPleaseWait(false);
        setWithdrawing([]);
        setQuoteItemIds([]);
        setVersion(version + 1);
        setSuccessMessage("Your changes were saved successfully.");
        setErrorMessage(null);
        onChange && onChange();
      })
      .catch((e) => {
        setErrorMessage(e.toString());
        setSuccessMessage(null);
        setPleaseWait(false);
      });
  };

  const clearMessages = () => {
    setErrorMessage(null);
    setSuccessMessage(null);
  };

  const handleUpdateQuoteItems = (quote_item_ids) => {
    setQuoteItemIds(quote_item_ids);
    clearMessages();
  };

  const handleUpdateWithdrawals = (withdrawing) => {
    setWithdrawing(withdrawing);
    clearMessages();
  };

  return (
    <div key={version} style={{ marginBottom: 10 }}>
      {!displayOnly && (
        <div className="sample_testing">
          <div
            className="basic-panel with-padding with-rounded-corners with-shadow"
            style={{ margin: 0, marginBottom: 10 }}
          >
            <div style={{ display: "flex", marginBottom: 20 }}>
              <Button
                title={pleaseWait ? "Please wait.." : "Save Changes"}
                disabled={pleaseWait}
                icon="fa-save"
                primary
                onClick={handleSubmit}
              />
              {errorMessage && (
                <div
                  className="alert alert-danger"
                  style={{ marginLeft: 20, marginBottom: 0, padding: 5 }}
                >
                  {errorMessage}
                </div>
              )}
              {successMessage && (
                <div
                  className="alert alert-success"
                  style={{ marginLeft: 20, marginBottom: 0, padding: 5 }}
                >
                  {successMessage}
                </div>
              )}
            </div>
            <ExistingSampleQuotables
              sampleId={sampleId}
              onWithdrawal={handleUpdateWithdrawals}
              withdrawing={withdrawing}
              displayOnly={displayOnly}
            />
            <AdditionalTestingSelector
              sampleId={sampleId}
              quote_item_ids={quoteItemIds}
              onChangeQuoteItems={handleUpdateQuoteItems}
              companyId={companyId}
              clientSpecificationId={clientSpecificationId}
            />
          </div>
        </div>
      )}
      {displayOnly && (
        <ExistingSampleQuotables
          sampleId={sampleId}
          onWithdrawal={handleUpdateWithdrawals}
          withdrawing={withdrawing}
          displayOnly={displayOnly}
        />
      )}
    </div>
  );
}
